exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2C_VaX9fSnbjQvn4prDIax{display:flex;justify-content:center;width:100%}._22s1eUMMwiFPmsxcdktPce{flex:1;align-self:flex-start}.KJabrUjRr16p5xviI3B81{flex:2;line-height:100px;text-align:center}._1LRvoEZX5r4gVOfQaEa9J8{font-size:24px;margin-top:12px;margin-left:10px}._1LRvoEZX5r4gVOfQaEa9J8>:first-child{margin-bottom:5px}._2U7ZCQg4rm_okcbJMJdSg6{color:#e3e5e5;height:25px;margin-bottom:-18px}._2XrcowivjtwZnsEGht6xPB{color:#8dc63f}._3M2gV6g3LiB5uV4Z90tnQx{color:#be1e2d}", ""]);

// exports
exports.locals = {
	"number": "_2C_VaX9fSnbjQvn4prDIax",
	"aside": "_22s1eUMMwiFPmsxcdktPce",
	"value": "KJabrUjRr16p5xviI3B81",
	"trendIndicators": "_1LRvoEZX5r4gVOfQaEa9J8",
	"trendIcon": "_2U7ZCQg4rm_okcbJMJdSg6",
	"trendGood": "_2XrcowivjtwZnsEGht6xPB",
	"trendBad": "_3M2gV6g3LiB5uV4Z90tnQx"
};


//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/node_modules/css-loader!../graylog2-server/graylog2-web-interface/src/components/visualizations/NumericVisualization.css
// module id = 777
// module chunks = 0